// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox[data-v-72a02bed]{filter:hue-rotate(300deg) brightness(1.2)}", ""]);
// Exports
module.exports = exports;
